export class HWPXError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'HWPXError';
  }
}

export class HWPXValidationError extends HWPXError {
  public readonly field: string;

  constructor(field: string, message: string) {
    super(`Validation error on "${field}": ${message}`);
    this.name = 'HWPXValidationError';
    this.field = field;
  }
}
